import { CHECK_TEXT, CLICK, component, demoFile, extend, INPUT, POPUP, story, variant, feature, componentWithVariants } from "system/demo";
import { DerivedAnswer, ProfileAnswersFeature, ViewProfileAnswers } from 'feature/profile/profile-answers';
import { ProfileModuleHolder } from "structure/profile";
import { View } from "react-native-web";
import { StructureDemo } from "util/instance";

demoFile('feature/profile/profile-answers', {
    designUrl: 'https://www.figma.com/design/iP7DEaY8SVqQcEGN6Feipj/Basic-Profile-%2B-Privacy-Settings?node-id=475-5263&'
});

componentWithVariants('DerivedAnswer', DerivedAnswer, {}, [
    variant('Normal Answer', {
        args: {
            answer: {
                instanceKey: 'a',
                question: 'What is your favorite color?',
                text: 'My favorite color is Blue',
                time: 1000
            }
        }
    }),
    variant('Answer In Review', {
        args: {
            answer: {
                instanceKey: 'a',
                question: 'What is the rudest word you know?',
                inReview: true,
                violates: true,
                text: 'Rude text that is in review',
                time: 2000
            }
        }
    }),
    variant('Rejected Answer', {
        args: {
            answer: {
                instanceKey: 'a',
                question: 'What is your opinion of Godzilla?',
                violates: true,
                text: 'Rude text that got rejected',
                time: 2000
            }
        }
    })
]);

componentWithVariants('ViewProfileAnswers', ViewProfileAnswers, {}, [
    variant('Visible Answers', {
        args: {},
        state: {
            collections: {
                derived_answer: [
                    {
                        question: 'Is Godzilla nice?',
                        text: 'Godzilla is very nice',
                        time: 2000,
                        structureKey: 'question',
                        instanceKey: 'q1'
                    },
                    {
                        question: 'What is your favorite animal?',
                        text: 'I like Komodo Dragons. They are very friendly, but sometimes they eat you.',
                        time: 3000,
                        structureKey: 'question',
                        instanceKey: 'q2'
                    }
                ]
            }
        }
    }),
    variant('Hidden Answers', {
        args: {},
        state: {
            collections: {
                derived_answer: [
                    {
                        question: 'Is Godzilla nice?',
                        text: 'Godzilla is very nice',
                        time: 2000,
                        structureKey: 'question',
                        instanceKey: 'q1'
                    }
                ]
            },
            globals: {
                fields: { answersVisible: false }
            }
        }
    }),
    variant('Hidden Answers Admin View', {
        args: {},
        state: {
            collections: {
                derived_answer: [
                    {
                        question: 'Is Godzilla nice?',
                        text: 'Godzilla is very nice',
                        time: 2000,
                        structureKey: 'question',
                        instanceKey: 'q1'
                    }
                ]
            },
            globals: {
                fields: { answersVisible: false }
            },
            roles: ['Owner']
        }
    })
]);

extend('ProfileModuleHolder', 'Edit Profile Answers', ProfileModuleHolder, {
    args: {
        module: ProfileAnswersFeature.config?.profileModules?.[0]
    },
    instanceKey: 'a',
    state: {
        personaKey: 'a',
        collections: {
            derived_answer: [
                {
                    question: 'Is Godzilla nice?',
                    text: 'Godzilla is very nice',
                    time: 2000,
                    structureKey: 'question',
                    instanceKey: 'q1'
                }
            ]
        },
        serverCall: {
            profile: {
                update: async ({datastore, updates, preview}) => {
                    datastore.updateGlobalProperty('fields', updates);
                    datastore.updateObject('persona', 'a', preview);
                    return Promise.resolve();
                }
            },
            eventlog: {
                logEvent: async () => Promise.resolve()
            }
        }
    },
}, [
    story('Hide Answers', [
        CLICK('Edit {tLabel}'),
        CLICK('Visible to everyone'),
        CLICK('Save')
    ]),
    story('Hide & Show Answers', [
        CLICK('Edit {tLabel}'),
        CLICK('Visible to everyone'),
        CLICK('Save'),
        CLICK('Edit {tLabel}'),
        CLICK('Visible to everyone'),
        CLICK('Save')
    ])
]);

const derived_answer = [
    {
        question: 'Is Godzilla nice?',
        text: 'Godzilla is very nice',
        time: 2000,
        structureKey: 'question',
        instanceKey: 'q1'
    },
    {
        question: 'What is your favorite animal?',
        text: 'I like Komodo Dragons. They are very friendly, but sometimes they eat you.',
        time: 3000,
        structureKey: 'question',
        instanceKey: 'q2'
    }
];

feature('profileanswers', {
    structureKey: 'profile',
    instanceKey: 'a',
    features: {
        profileanswers: true,
        profileeditname: true
    },
    state: {
        globals: {
            initialized: true
        },
        collections: {
            derived_answer
        }
    }
});
